/**
 * GREENWIPES® THEME - PDP CONTROLLER & SAMPLE DRAWER
 */
document.addEventListener('DOMContentLoaded', () => {
  initGalleryZoom();
  initFormatSelector();
  initInteractiveTabs();
  initRoiCalculator();
  initSampleDrawer();
});

function initGalleryZoom() {
  const mainImg = document.querySelector('[data-gw-pdp-main-image]');
  const zoomStage = document.querySelector('[data-gw-zoom-container]');
  const thumbBtns = document.querySelectorAll('[data-gw-pdp-thumb]');

  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const newSrc = btn.getAttribute('data-gw-pdp-thumb');
      if (newSrc && mainImg) {
        mainImg.style.opacity = '0.3';
        setTimeout(() => {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 100);
      }
    });
  });

  if (zoomStage && mainImg) {
    zoomStage.addEventListener('mousemove', (e) => {
      const rect = zoomStage.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = `${x}% ${y}%`;
      mainImg.style.transform = 'scale(1.75)';
    });
    zoomStage.addEventListener('mouseleave', () => {
      mainImg.style.transform = 'scale(1)';
      mainImg.style.transformOrigin = 'center center';
    });
  }
}

function initFormatSelector() {
  const cards = document.querySelectorAll('.gw-format-card');
  const skuTag = document.querySelector('.gw-sku-tag strong');

  cards.forEach(card => {
    card.addEventListener('click', () => {
      cards.forEach(c => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      const sku = card.getAttribute('data-sku');
      if (skuTag && sku) skuTag.textContent = sku;

      const primaryPill = document.querySelector('.gw-sample-pill.is-primary');
      if (primaryPill) {
        primaryPill.setAttribute('data-sku', sku);
        const nameEl = card.querySelector('.gw-format-name');
        const name = nameEl ? nameEl.textContent : sku;
        primaryPill.querySelector('.gw-pill-text').innerHTML = `<strong>${sku}</strong> (${name} trial)`;
      }
    });
  });
}

function initInteractiveTabs() {
  const tabBtns = document.querySelectorAll('.gw-tab-btn');
  const panels = document.querySelectorAll('.gw-tab-panel');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = `tab-${btn.getAttribute('data-tab')}`;
      tabBtns.forEach(b => {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      panels.forEach(p => {
        if (p.id === targetId) {
          p.classList.add('is-active');
        } else {
          p.classList.remove('is-active');
        }
      });
    });
  });
}

function initRoiCalculator() {
  const slider = document.getElementById('rag-usage-slider');
  const countDisplay = document.getElementById('rag-count-display');
  const savingsDisplay = document.getElementById('calc-savings-display');
  const wasteDisplay = document.getElementById('calc-waste-display');

  if (!slider) return;

  function update() {
    const monthlyRags = parseInt(slider.value, 10);
    const unit = slider.getAttribute('data-unit') || 'rags';
    const currency = slider.getAttribute('data-currency') || '$';
    const savingsRate = parseFloat(slider.getAttribute('data-savings-rate')) || 0.16;
    const wasteRate = parseFloat(slider.getAttribute('data-waste-rate')) || 0.04;

    countDisplay.textContent = `${monthlyRags.toLocaleString()} ${unit}`;
    const annualRags = monthlyRags * 12;
    const annualSavings = Math.round(annualRags * savingsRate);
    savingsDisplay.textContent = `${currency}${annualSavings.toLocaleString()}`;
    const wasteSavedKg = Math.round(annualRags * wasteRate);
    wasteDisplay.textContent = `${wasteSavedKg.toLocaleString()} kg`;
  }

  slider.addEventListener('input', update);
  update();
}

function initSampleDrawer() {
  const drawer = document.getElementById('sample-drawer');
  const backdrop = document.getElementById('sample-drawer-backdrop');
  const closeBtn = document.getElementById('close-sample-drawer-btn');
  const form = document.getElementById('sample-request-form');
  const formView = document.getElementById('sample-request-form');
  const successView = document.getElementById('sample-success-view');
  const successDoneBtn = document.getElementById('success-done-btn');
  const selectedList = document.getElementById('selected-samples-list');

  function openDrawer() {
    if (!drawer || !backdrop) return;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-sample-drawer]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const cardTitle = el.getAttribute('data-card-title');
      if (cardTitle) {
        const primaryPill = document.querySelector('.gw-sample-pill.is-primary');
        if (primaryPill) {
          const skuMatch = cardTitle.match(/GW-[\w\d]+|GShield-[\w\d]+/i);
          const sku = skuMatch ? skuMatch[0] : 'Sample';
          primaryPill.setAttribute('data-sku', sku);
          primaryPill.querySelector('.gw-pill-text').innerHTML = `<strong>${sku}</strong> (${cardTitle} trial)`;
        }
      }
      openDrawer();
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Adding companion trial tags
  const addTags = document.querySelectorAll('.gw-tag-add');
  addTags.forEach(tag => {
    tag.addEventListener('click', () => {
      const sku = tag.getAttribute('data-add-sku');
      const name = tag.getAttribute('data-add-name');
      if (document.querySelector(`.gw-sample-pill[data-sku="${sku}"]`)) return;

      const currentCount = selectedList.querySelectorAll('.gw-sample-pill').length;
      if (currentCount >= 3) {
        alert('You have reached the maximum of 3 trial products per sample kit.');
        return;
      }

      const pill = document.createElement('div');
      pill.className = 'gw-sample-pill';
      pill.setAttribute('data-sku', sku);
      pill.innerHTML = `
        <span class="gw-pill-icon">&#10003;</span>
        <span class="gw-pill-text"><strong>${sku}</strong> (${name})</span>
        <button type="button" class="gw-pill-remove" aria-label="Remove item">&times;</button>
      `;

      pill.querySelector('.gw-pill-remove').addEventListener('click', () => {
        pill.remove();
        tag.style.opacity = '1';
        tag.style.pointerEvents = 'auto';
      });

      selectedList.appendChild(pill);
      tag.style.opacity = '0.4';
      tag.style.pointerEvents = 'none';
    });
  });

  // Accessories add-to-sample buttons
  document.querySelectorAll('[data-add-accessory-sample]').forEach(btn => {
    btn.addEventListener('click', () => {
      const sku = btn.getAttribute('data-sku');
      const name = btn.getAttribute('data-name');
      openDrawer();

      if (!document.querySelector(`.gw-sample-pill[data-sku="${sku}"]`)) {
        const currentCount = selectedList.querySelectorAll('.gw-sample-pill').length;
        if (currentCount < 3) {
          const pill = document.createElement('div');
          pill.className = 'gw-sample-pill';
          pill.setAttribute('data-sku', sku);
          pill.innerHTML = `
            <span class="gw-pill-icon">&#10003;</span>
            <span class="gw-pill-text"><strong>${sku}</strong> (${name})</span>
            <button type="button" class="gw-pill-remove" aria-label="Remove">&times;</button>
          `;
          pill.querySelector('.gw-pill-remove').addEventListener('click', () => pill.remove());
          selectedList.appendChild(pill);
        }
      }
    });
  });

  // Form submit
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = document.getElementById('sample-submit-btn');
      const fullName = document.getElementById('sample-fullname')?.value || 'Partner';
      const email = document.getElementById('sample-email')?.value || 'your email';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = `<span>Processing Facility Dispatch...</span>`;
      }

      setTimeout(() => {
        if (formView) formView.style.display = 'none';
        if (successView) successView.style.display = 'flex';
        const nameTarget = document.getElementById('success-contact-name');
        const emailTarget = document.getElementById('success-contact-email');
        if (nameTarget) nameTarget.textContent = fullName;
        if (emailTarget) emailTarget.textContent = email;

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = `<span>Dispatch Free Sample Kit &rarr;</span>`;
        }
      }, 700);
    });
  }

  if (successDoneBtn) {
    successDoneBtn.addEventListener('click', () => {
      closeDrawer();
      setTimeout(() => {
        if (formView) formView.style.display = 'flex';
        if (successView) successView.style.display = 'none';
        if (form) form.reset();
      }, 400);
    });
  }
}
